var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTips({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 5.125C9.25 5.74634 8.74634 6.25 8.125 6.25C7.50366 6.25 7 5.74634 7 5.125C7 4.50366 7.50366 4 8.125 4C8.74634 4 9.25 4.50366 9.25 5.125Z",
    fill: "#F5821E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11V7H6.5C6.22388 7 6 7.22388 6 7.5C6 7.77612 6.22388 8 6.5 8H7V11H6.5C6.22388 11 6 11.2239 6 11.5C6 11.7761 6.22388 12 6.5 12H9.5C9.77612 12 10 11.7761 10 11.5C10 11.2239 9.77612 11 9.5 11H9Z",
    fill: "#F5821E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.28 14.76C11.0424 15.5453 9.57428 16 8 16C3.58173 16 0 12.4183 0 8C0 3.58167 3.58173 0 8 0C12.4183 0 16 3.58167 16 8C16 9.57422 15.5453 11.0424 14.76 12.28L16 16L12.28 14.76ZM14 8C14 11.3137 11.3137 14 8 14C4.68628 14 2 11.3137 2 8C2 4.68628 4.68628 2 8 2C11.3137 2 14 4.68628 14 8Z",
    fill: "#F5821E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTips);
export default __webpack_public_path__ + "static/media/icon-tips.b1da4d3515465c878a81f27705f266d3.svg";
export { ForwardRef as ReactComponent };